<template>
  <div :class="inverse ? `card text-white bg-${color}` : 'card'">
    <div class="card-body pl-4 pr-4">
      <div
          class="h1 text-muted text-right mb-4"
          v-if="$slots.default"
      >
        <slot></slot>
      </div>
      <div class="h4 mb-0 font-4xl" v-if="header">{{ header }}</div>
      <div class="h4 mb-0 font-4xl" v-else>0</div>
      <p
          class="text-muted text-uppercase font-weight-bold mb-0"
          v-if="text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CWidgetProgressIcon',
  props: {
    header: Number,
    text: String,
    color: String,
    inverse: Boolean,
    value: {
      type: Number,
      default: 25
    }
  }
}
</script>
